import React from 'react';
import { Box, Flex, LayoutGrid, LayoutGridItem, PrimaryButton, TextHeadingTwo, } from '@cko/primitives';
import { IconActionAttention } from '@cko/icons';
import styled from 'styled-components';
export const BLOCKED_PAGE_TEST_IDS = {
    changeViewButton: 'test-change-view-button',
    wrapper: 'test-blocked-modal-wrapper',
};
const IconBox = styled(Box) `
  border-radius: var(--border-r-seed);
  background-color: var(--control-bg-warn-decorative);
  margin-bottom: var(--layout-shoe);
  padding: var(--layout-stamp);
`;
const AlertIcon = styled(IconActionAttention) `
  g {
    fill: var(--control-icon-warn);
  }
`;
export const BlockedPage = ({ onChangeViewClick, requiredAccountName, }) => (React.createElement(LayoutGrid, { "data-testid": BLOCKED_PAGE_TEST_IDS.wrapper, paddingTop: "var(--layout-saxophone)" },
    React.createElement(LayoutGridItem, { span: 24 },
        React.createElement(Flex, { alignItems: "center", flexDirection: "column" },
            React.createElement(IconBox, null,
                React.createElement(AlertIcon, null)),
            React.createElement(TextHeadingTwo, { marginBottom: "var(--layout-shoe)" },
                "Switch to ",
                requiredAccountName,
                " to view this page"),
            React.createElement(PrimaryButton, { "data-testid": BLOCKED_PAGE_TEST_IDS.changeViewButton, onClick: onChangeViewClick }, "Switch view")))));
